<template>
  <div style="padding: 0 16px 16px;">
    <div v-if="pageDataList.length > 0">
      <div v-for="(item,index) in pageDataList" :key="index" style="margin-bottom: 20px;">
        <span>{{ item.createTime }}</span>
        <el-tag v-if="item.adminName" size="small" style="margin-left: 8px;">{{ item.adminName }}</el-tag>
        <p>{{ item.marriageName }}</p>
      </div>
    </div>
    <el-empty v-else description="没有记录"></el-empty>
    <!--分页-->
    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">
    </el-pagination>
  </div>
</template>

<script>
import { getFormData } from '../../api/api';
import { getMarriagePageDtList } from '../../api/url';
export default {
  props: {
    value: Object
  },
  data() {
    return {
      pageDataList: [],
      id: this.value.id,
      totalRow: 0,
      pagesize: 20,
      currentPage: 1,
    }
  },
  methods: {
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage() {
      let param = {
        'id': this.id,
        'pageNum': this.currentPage
      }
      getFormData(getMarriagePageDtList, param).then((data) => {
        if(data.code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pagesize = result['size'];
        }
      })
    },

  },
  mounted() {
    sessionStorage.removeItem('userLog');
    this.getPage();
  }
}
</script>

<style>

</style>
